import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const deleteProductSetting = async (productSettingId) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.surpriseboxsetting/delete': {
                    productSettingId: Number(productSettingId)
                },
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}